const dev = {
  apiGateway: { URL: 'http://localhost:4000/api' },
  environment: 'DEVELOPMENT',
}

const stage = {
  apiGateway: { URL: 'https://demo.electricservice.com.br/api' },
  environment: 'DEMONSTRAÇÃO',
}

const prod = {
  apiGateway: {
    URL: process.env.REACT_APP_PROD_API
      ? process.env.REACT_APP_PROD_API
      : 'https://api.electricservice.com.br/api',
  },
  environment: '',
}

const config =
  process.env.REACT_APP_STAGE === 'production'
    ? prod
    : process.env.REACT_APP_STAGE === 'local'
    ? dev
    : process.env.NODE_ENV === 'production'
    ? stage
    : dev

export default {
  ...config,
}
